import React, { useEffect } from "react";

// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
// import AppBar from "@material-ui/core/AppBar";
// import Toolbar from "@material-ui/core/Toolbar";
// import logoLFA from "../../assets/img/LogoCinza.png";
import logoUFLA from "../../assets/img/logo-ufla.png";
import willianBrandao from "../../assets/img/developers/willianBrandao.jpg";
import marcos from "../../assets/img/developers/marcos1.jpg";
import takeshi from "../../assets/img/developers/takeshi1.jpg";
import terra from "../../assets/img/developers/terra1.jpg";
import pedro from "../../assets/img/developers/pedro.jpg";
import tulio from "../../assets/img/developers/tulio.jpg";
import automaton from "../../assets/img/LogoAutomato 1.png";
import grammar from "../../assets/img/LogoGrammar.png";
import constanst from "../../constants/About/about";

// core components
// import AdminNavbarLinks from "../../components/Navbars/AdminNavbarLinks.js";
// import RTLNavbarLinks from "../../components/Navbars/RTLNavbarLinks";
// import Button from "../CustomButtons/Button";

import { useUser } from "../../context/userContext";
//hooks
import "./About.css";
// import styles from "../../assets/jss/material-dashboard-react/components/headerStyle.js";

// const useStyles = makeStyles(styles);

export default function About() {
  // const classes = useStyles();

  // const { color } = props;
  // const appBarClasses = classNames({
  //   [" " + classes[color]]: color,
  // });
  const { isAdmin, setIsAdmin, language } = useUser();

  useEffect(() => {
    setIsAdmin(isAdmin);
  }, [isAdmin]);

  return (
    <div className="sections">
      <section id="about">
        <div className="container-about">
          <div className="wrapper-about-title">
            <h1>{constanst.aboutProject.title1[language]}&nbsp;</h1>
            <h1 style={{ fontWeight: "500" }}>
              {constanst.aboutProject.title2[language]}
            </h1>
          </div>
          <div className="container-text-about">
            <div className="wrapper-text-about">
              <span className="wrapper-text text">
                {constanst.aboutProject.description[language]}
              </span>
            </div>
          </div>
          <div className="container-ufla">
            <div className="container-img">
              <img src={logoUFLA}></img>
            </div>
          </div>
        </div>
      </section>
      <section id="funcionalidades">
        <div className="container-funcionalidades">
          <div className="wrapper-about-title">
            <h1>{constanst.functionalities.title1[language]}&nbsp;</h1>
            <h1>{constanst.functionalities.title2[language]}</h1>
          </div>
          <div className="funcionalidades">
            <div className="section-home-second">
              <div className="wrapper-funcionalidades">
                <img className="funcionalidade-logo" src={grammar}></img>
                <h2>{constanst.functionalities.grammar.title[language]}</h2>
                <div className="funcionalidade-itens">
                  <ul>
                    <li>
                      {
                        constanst.functionalities.grammar.items.validateGrammar[
                          language
                        ]
                      }
                    </li>
                    <ul>
                      <li>
                        {constanst.functionalities.grammar.items.GR[language]}
                      </li>
                      <li>
                        {constanst.functionalities.grammar.items.GLC[language]}
                      </li>
                      <li>
                        {constanst.functionalities.grammar.items.GSC[language]}
                      </li>
                      <li>
                        {constanst.functionalities.grammar.items.GI[language]}
                      </li>
                    </ul>

                    <li>
                      {
                        constanst.functionalities.grammar.items.Chomsky[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {
                        constanst.functionalities.grammar.items.Greibach[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {
                        constanst.functionalities.grammar.items.PushDown[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {constanst.functionalities.grammar.items.CYK[language]}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="section-home-second">
              <div className="wrapper-funcionalidades-maquina">
                <img className="funcionalidade-logo" src={automaton}></img>
                <h2>{constanst.functionalities.machine.title[language]}</h2>
                <div className="funcionalidade-itens">
                  <ul>
                    <li>
                      {
                        constanst.functionalities.machine.items.drawAutomata[
                          language
                        ]
                      }
                    </li>
                    <ul>
                      <li>
                        {
                          constanst.functionalities.machine.items.AFNDLambda[
                            language
                          ]
                        }
                      </li>
                      <li>
                        {constanst.functionalities.machine.items.AFND[language]}
                      </li>
                      <li>
                        {constanst.functionalities.machine.items.AFD[language]}
                      </li>
                    </ul>

                    <li>
                      {
                        constanst.functionalities.machine.items
                          .convertionAFNDLambda[language]
                      }
                    </li>

                    <li>
                      {
                        constanst.functionalities.machine.items.complete[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {
                        constanst.functionalities.machine.items.minimize[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {constanst.functionalities.machine.items.regex[language]}
                    </li>
                    <li>
                      {
                        constanst.functionalities.machine.items.simulate[
                          language
                        ]
                      }
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="integrantes">
        <div className="section-team">
          <div className="wrapper-about-title">
            <h1>
              {constanst.team.title1[language]}
              &nbsp;
            </h1>
            <h1>{constanst.team.title2[language]}</h1>
          </div>

          <div className="div-integrantes-text">
            <div className="wrapper-text text">
              <span>{constanst.team.about[language]}</span>
            </div>
          </div>

          <div className="div-developers">
            {/* <div className="wrapper-developers"> */}
            <div className="developers-row1">
              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={willianBrandao}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="https://github.com/WillianBrandao"
                  target="_blank"
                >
                  <h3 className="name">Willian Brandão</h3>
                </a>

                <span className="function">
                  {constanst.team.function.developer[language]}
                </span>
              </div>
              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={takeshi}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="https://github.com/4andrewtanakashi"
                  target="_blank"
                >
                  <h3 className="name">Andrew Takeshi</h3>
                </a>

                <span className="function">
                  {constanst.team.function.developer[language]}
                </span>
              </div>
            </div>
            <div className="developers-row1">
              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={marcos}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="https://github.com/Marcos-Pimentel"
                  target="_blank"
                >
                  <h3 className="name">Marcos Pimentel</h3>
                </a>

                <span className="function">
                  {constanst.team.function.developer[language]}
                </span>
              </div>

              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={tulio}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="https://github.com/tuliocruz16"
                  target="_blank"
                >
                  <h3 className="name">Tulio Cruz</h3>
                </a>

                <span className="function">
                  {constanst.team.function.developer[language]}
                </span>
              </div>
            </div>
            <div className="developers-row1">
              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={pedro}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="https://github.com/Pedronorton"
                  target="_blank"
                >
                  <h3 className="name">Pedro Paiva</h3>
                </a>

                <span className="function">
                  {constanst.team.function.developer[language]}
                </span>
              </div>
              <div className="wrapper-img">
                <div className="members-container-img">
                  <img className="img" src={terra}></img>
                </div>
                <a
                  className="developer-links"
                  rel="noreferrer"
                  href="http://professores.dcc.ufla.br/~terra/"
                  target="_blank"
                >
                  <h3 className="name">Ricardo Terra</h3>
                </a>
                <span className="function">
                  {constanst.team.function.academicAdvisor[language]}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
